import {useCallback} from 'react'
import {useAccount} from 'wagmi'
import {DarkModeStore} from '@store/DarkmodeStore'

import MetaMask from '@svg/wallet/ic_metamask.svg'
import WalletConnect from '@svg/wallet/ic_wallet_wallet_connect.svg'
import Rainbow from '@svg/wallet/ic_wallet_rainbow.svg'
import Ledger from '@svg/wallet/ic_wallet_ledger.svg'
import Binance from '@svg/wallet/ic_wallet_binance.svg'
import Bybit from '@svg/wallet/ic_wallet_bybit.svg'
import Bitget from '@svg/wallet/ic_wallet_bitget.svg'
import OKX from '@svg/wallet/ic_wallet_okx.svg'
import OneInch from '@svg/wallet/ic_wallet_1inc.svg'
import Coinbase from '@svg/wallet/ic_wallet_coinbase.svg'

import DefaultLight from '@svg/wallet/ic_wallet_default_light.svg'
import DefaultDark from '@svg/wallet/ic_wallet_default_dark.svg'

const WalletIcon = ({darkOnly}: {darkOnly?: boolean}) => {
    const {connector} = useAccount()
    const {isDark} = DarkModeStore()

    const getIcon = useCallback(() => {
        switch (connector?.name) {
            case 'MetaMask':
                return <MetaMask />
            case 'Rainbow':
                return <Rainbow />
            case 'Binance Wallet':
                return <Binance />
            case 'Bybit Wallet':
                return <Bybit />
            case 'Bitget Wallet':
                return <Bitget />
            case 'OKX Wallet':
                return <OKX />
            case '1inch Wallet':
                return <OneInch />
            case 'Ledger':
                return <Ledger />
            case 'Coinbase Wallet':
                return <Coinbase />
            case 'WalletConnect':
                return <WalletConnect />
            default:
                return darkOnly ? <DefaultDark /> : isDark ? <DefaultDark /> : <DefaultLight />
        }
    }, [connector?.name, isDark, darkOnly])
    return getIcon()
}
export default WalletIcon
